// @ts-check

/** @type import("../../types/themes").PartialAliasGenerator */
const aliases = (palette) => ({
  background: {
    dark: palette.gray["100"],
    default: palette.gray["200"],
    light: palette.gray["999"],
    strong: palette.gray["300"],
  },
  border: {
    default: palette.gray["400"],
  },
  outline: {
    focusAlternative: palette.gray["999"],
    hover: `color-mix(in srgb, ${palette.gray["100"]} 50%, transparent)`,
  },
  overlay: {
    dark: palette.gray["000"],
    light: palette.gray["999"],
  },
  shadow: {
    default: palette.gray["000"],
    light: `0 2px 6px 0 color-mix(in srgb, ${palette.gray["100"]} 10%, transparent)`,
    medium: `0 8px 24px 0 color-mix(in srgb, ${palette.gray["100"]} 20%, transparent)`,
    strong: `0 16px 48px 0 color-mix(in srgb, ${palette.gray["100"]} 33%, transparent)`,
  },
  text: {
    placeholder: palette.gray["600"],
    light: palette.gray["999"],
    dark: palette.gray["000"],
  },
});

export default aliases;
